import * as React from 'react'
// components
import { components, ControlProps } from 'react-select'
import OpenRiskLink from 'components/FormElements/components/OpenRiskLink'
// constants
import { ENTITIES } from 'constants/entities'
// types
import { IOption } from 'components/FormElements/Select'

const OpenRiskControl: React.FC<ControlProps<IOption, boolean>> = (props) => {
  const [value] = props.getValue()

  const isRisk = value?.entity === ENTITIES.RISK && value.riskTemplateId

  return (
    <components.Control {...props}>
      {props.children}
      {isRisk && <OpenRiskLink riskId={value.value} riskTemplateId={value.riskTemplateId} />}
    </components.Control>
  )
}

export default OpenRiskControl
